import { CXPage } from '~/components/ClientExperience/OneFlow/models/cx-page.model';
import { IImage } from '~/types/model.types';

export const BLOCK_ID_QUERY_PARAM = 'tb';

export const DEFAULT_CAPTURE_THUMBNAIL_PARAMS = {
    delay: 5
};

export type CaptureThumbnailParams = Partial<
    typeof DEFAULT_CAPTURE_THUMBNAIL_PARAMS
> & {
    viewport?: `${string}X${string}`;
    target_block_id: string;
    page_number: number;
    template_id: string;
};

export type TPageThumbnail = {
    image: IImage;
    title: string;
};

export type TPageThumbnails = {
    image: IImage;
    title: string;
}[];

export type TTemplateThumbnails = {
    templateThumbnailsPerPage: {
        pageTitle: string;
        thumbnails: TPageThumbnails;
    }[];
    templateImage: IImage;
};

export type GetCaptureParams = {
    page: CXPage;
    pageIndex: number;
    template_id: string;
    blocksForCapture: {
        id: string;
        title?: string;
        captureParams?: CaptureThumbnailParams;
    }[];
};
